<script>
  import TableDropdown from "../components/Dropdowns/TableDropdown.svelte";
  import Swal from 'sweetalert2';
  import { onMount, onDestroy } from "svelte";
  import * as XLSX from 'xlsx';
  import { jsPDF } from "jspdf";
  import "jspdf-autotable";    
  import Paginator from './Paginator.svelte';
  import Actions from './Actions.svelte';
  import CrudPane from "./CRUDPane.svelte";
  import CrudObjectPane from "./CrudObjetoPane.svelte";
  import { fetchSucursales } from '../controllers/sucursalController.js';
  import { fetchEmpresas } from '../controllers/empresaController.js';
  import { fetchVendedores } from '../controllers/vendedorController.js';
  import { fetchRoles } from '../controllers/roleController.js';
  import { POCKETBASE_URL } from "../config";
  import { authStore, initializeAuth } from '../lib/authStore.js';
  import { get } from 'svelte/store';
  import { Router, Route, navigate } from "svelte-routing";
  import pb from '../lib/pocketbase.js';
  import ChangePasswordModal from '../components/ChangePasswordModal.svelte';

  // Parámetros que se pueden reutilizar
  export let title = '';               // Título (e.g., Vendedores)
  export let entityName = '';           // Nombre de la entidad (e.g., vendedor)
  export let newEntity = {};            // Objeto del nuevo registro
  export let fetchEntities;             // Función para obtener los registros
  export let saveEntity;                // Función para guardar el registro
  export let removeEntity;              // Función para eliminar
  export let columns = [];              // Columnas de la tabla
  export let searchEntities;            // Función para buscar registros
  export let subscribeToChanges;        // Función para suscribirse a cambios
  export let unsubscribeFromChanges;    // Función para cancelar la suscripción
  export let editColumns;
  export let fetchAtributos = {};
  export let fetchImpuestos = {};

const params = window.location.pathname.split('/');
const objetoId = params[params.length - 1]; // Obtiene el último parámetro

  const { authData } = get(authStore);
  let userRole = '';
  
    if (authData) {
      userRole = JSON.parse(authData).role;
    } else {
      navigate('/auth/login');
    }
  
  let entities = [];
  let totalRecords = 0;
  let currentPage = 1;
  let perPage = 10;
  let searchQuery = '';
  let isPaneOpen = false;
  let isObjectPaneOpen = false;
  let currentEntityId = null;
  let isDirty = false;
  let itemsPerPageOptions = [10, 20, 50, 100, 500];

  let isMenuOpen = false; // Estado para controlar el menú hamburguesa
  
  let sortColumn = ''; // Nueva variable para almacenar la columna de ordenación
  let sortDirection = 'asc'; 

  let sucursalOptions = [];
  let empresaOptions = [];

  let canCreate = false; // Variable para manejar la visibilidad del botón "Crear"
  let canModify = false; // Variable para manejar la visibilidad del botón "Modificar"
  let canDelete = false; // Variable para manejar la visibilidad del botón "Eliminar"
  let showComponent = false; // Variable para manejar la visibilidad del componente
  let crudPermission = null;

  let showPasswordModal = false;
  let selectedUserId = '';

  function toggleMenu() {
    isMenuOpen = !isMenuOpen; // Cambia el estado del menú
  }

  // Funciones reutilizables
  async function handleSearch(page = 1) {
    const data = searchQuery.trim() === ''
      ? await fetchEntities(page, perPage)
      : await searchEntities(searchQuery, page, perPage);
    updateEntitiesData(data, page);
  }

  // Función genérica para encontrar el nombre de una entidad por su ID
  export async function getEntityName(id, fetchFunction, entityName, keyField = 'id', valueField = 'descrip') {
      // Almacenamos las opciones cargadas en una variable estática por entidad
      if (!getEntityName.cache) {
          getEntityName.cache = {};
      }

      if (!getEntityName.cache[entityName]) {
          getEntityName.cache[entityName] = [];
      }

      // Si las opciones ya fueron cargadas, las usamos
      let entityOptions = getEntityName.cache[entityName];

      if (entityOptions.length === 0) {
          try {
              const fetchedData = await fetchFunction();

              if (fetchedData && Array.isArray(fetchedData[entityName])) {
                  // Mapea los resultados a un arreglo de { key, value }
                  entityOptions = fetchedData[entityName].map(e => ({
                      key: e[keyField],
                      value: e[valueField],
                  }));

                  // Almacena las opciones en caché
                  getEntityName.cache[entityName] = entityOptions;
              } else {
                  console.error(`La respuesta de ${entityName} no es válida:`, fetchedData);
                  return `${entityName} no encontrada`;
              }
          } catch (error) {
              console.error(`Error al cargar ${entityName}:`, error);
              return `Error al cargar ${entityName}`;
          }
      }

      // Buscar la entidad correspondiente por su ID
      const entity = entityOptions.find(option => option.key === id);

      if (entity) {
          return entity.value;
      } else {
          console.warn(`${entityName} con ID ${id} no encontrada`);
          return `${entityName} no encontrada`;
      }
  }
  async function updateEntitiesData(data, page) {
    if (data[entityName]) {
      let updatedEntities = [];

      for (let entity of data[entityName]) {
        // Si la entidad tiene una sucursal, reemplaza el ID por el nombre de la sucursal
        if (entity.sucursal) {
          const sucursalNombre = await getEntityName(entity.sucursal, fetchSucursales, 'sucursal', 'id', 'descrip');
          entity.sucursal_descrip = sucursalNombre;
        }
        // Si la entidad tiene una empresa, reemplaza el ID por el nombre de la empresa
        if (entity.empresa) {
          const empresaNombre = await getEntityName(entity.empresa, fetchEmpresas, 'empresa', 'id', 'nombre_comercial');
          entity.empresa_descrip = empresaNombre;
        }
        // Si la entidad tiene un role, reemplaza el ID por la descripción del role
        if (entity.role) {
          const roleDescrip = await getEntityName(entity.role, fetchRoles, 'role', 'id', 'descrip');
          entity.role_descrip = roleDescrip;
        }
        // Si la entidad tiene un vendedor, reemplaza el ID por el nombre del vendedor
        if (entity.vendedor) {
          const vendedorNombre = await getEntityName(entity.vendedor, fetchVendedores, 'vendedor', 'id', 'nombre');
          entity.vendedor_nombre = vendedorNombre;
        }
        updatedEntities.push(entity);
      }

      entities = updatedEntities;
      totalRecords = data.totalRecords || 0;
      currentPage = page;
    } else {
      resetEntityData();
    }
  }

  async function fetchEntitiesData(page = 1) {
    const data = await fetchEntities(page, perPage);
    updateEntitiesData(data, page);
  }

  async function saveEntry() {
    await saveEntity(newEntity, currentEntityId);
    await handleSearch(currentPage);
    togglePane();
    isDirty = false;
  }

  async function editEntity(entity) {
    newEntity = { ...entity };
    currentEntityId = entity.id;
    isPaneOpen = true;
    isDirty = true;

    // Cargar las opciones de las entidades relacionadas
    if (typeof fetchAtributos === 'function') {
      newEntity['atributos'] = await loadAtributos(currentEntityId);
    }

    if (typeof fetchImpuestos === 'function') {
      newEntity['impuestos'] = await loadImpuestos(currentEntityId);
    }
  }

  async function deleteEntity(id) {
    const result = await Swal.fire({
      title: `¿Está seguro de eliminar este ${entityName}?`,
      text: "Esta acción no se puede deshacer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminarlo!',
    });

    if (result.isConfirmed) {
      await removeEntity(id);
      await handleSearch(currentPage);
    }
  }

  onMount(async () => {
    handleSearch();
    if (typeof subscribeToChanges === 'function') {
      subscribeToChanges(searchQuery, handleSearch);
    }
    window.addEventListener('beforeunload', handleBeforeUnload);

    const permission = await checkRoleObjetoCRUD(objetoId, userRole);
    crudPermission = permission;
    if (crudPermission) {
      // Lógica para determinar permisos
      showComponent = crudPermission.includes('C'); // Si contiene 'C', mostrar el componente
      canCreate = crudPermission.includes('A'); // Si no contiene 'A', ocultar el botón "Crear"
      canModify = crudPermission.includes('M'); // Si no contiene 'M', ocultar el botón "Modificar"
      canDelete = crudPermission.includes('E'); // Si no contiene 'D', ocultar el botón "Eliminar"
    } else {
      console.log('No se encontró permiso CRUD.');
    }
    return () => {
      if (typeof unsubscribeFromChanges === 'function') {
        unsubscribeFromChanges();
      }
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  });

  function handleBeforeUnload(event) {
    if (isDirty) {
      const confirmationMessage = 'Usted tiene cambios sin guardar. ¿Realmente desea salir?';
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    }
  }

  function togglePane() {
    isPaneOpen = !isPaneOpen;
    if (!isPaneOpen) resetForm();
  }

  function resetForm() {
    newEntity = {sucursal_id: 1, sta: true};
    currentEntityId = null;
    isDirty = false;
  }

  async function handlePageChange(direction) {
    const newPage = currentPage + direction;
    const totalPages = Math.ceil(totalRecords / perPage);
    if (newPage > 0 && newPage <= totalPages) {
      await handleSearch(newPage);
    }
  }

  function handleItemsPerPageChange(newPerPage) {
      perPage = newPerPage;
      currentPage = 1; // Reset to the first page when changing items per page
      fetchEntitiesData(currentPage); // Fetch the data for the new items per page
  }

  function exportToExcel() {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Prepare data for the worksheet
    const wsData = [
        columns.map(column => column.label), // Header
        ...entities.map(entity => 
            columns.map(col => {
                // Obtiene el valor de la entidad basándose en la clave de columna
                if (col.field === 'sta' || col.field === 'default') {
                    return entity[col.field] ? 'Activo' : 'Inactivo'; // Mapea el valor booleano a 'Activo' o 'Inactivo'
                }
                return entity[col.field]; // Retorna el valor de la entidad para otras columnas
            })
        )
    ];

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, title);

    // Generate the Excel file and prompt the user to download
    XLSX.writeFile(wb, title + ".xlsx");
  }

  function exportToPDF() {
    const doc = new jsPDF();

    // Agregar el encabezado
    doc.setFontSize(18); // Tamaño de la fuente del título
    doc.text(title, 105, 10, { align: 'center' }); // Título centrado en la parte superior
    doc.setFontSize(12); // Tamaño de fuente para el resto del contenido

    // Define column headers
    const headers = [columns.map(column => column.label)];

    // Define rows (data)
    const rows = entities.map(entity => 
        columns.map(col => {
            // Maneja los valores booleanos para 'sta' y 'default'
            if (col.field === 'sta' || col.field === 'default') {
                return entity[col.field] ? 'Activo' : 'Inactivo'; // Mapea el valor booleano a 'Activo' o 'Inactivo'
            }
            return entity[col.field]; // Retorna el valor de la entidad para otras columnas
        })
    );

    // Use autoTable to create the table
    doc.autoTable({
        head: headers,
        body: rows,
        startY: 15, // Optional: where the table should start vertically
    });

    // Save the PDF
    doc.save(title + ".pdf");
  }


  function resetEntityData() {
    entities = [];
    totalRecords = 0;
    currentPage = 1;
  }

  function handleInputChange() {
    isDirty = true;
  }

  function sortTable(column) {
    if (sortColumn === column) {
        sortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
        sortColumn = column;
        sortDirection = 'asc';
    }

    entities = [...entities.sort((a, b) => {
        const valueA = a[column];
        const valueB = b[column];

        if (valueA < valueB) {
            return sortDirection === 'asc' ? -1 : 1;
        }
        if (valueA > valueB) {
            return sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
    })];
  }

  function formatDate(dateStr) {
    console.log('dateStr:', dateStr);
    const date = new Date(dateStr);
    if (isNaN(date)) return ''; // Manejo de fechas inválidas

    // Convert from UTC to Guatemala timezone (UTC-6)
    const guatemalaDate = new Date(date.getTime() - (6 * 60 * 60 * 1000));
    
    const day = String(guatemalaDate.getUTCDate()).padStart(2, '0');
    const month = String(guatemalaDate.getUTCMonth() + 1).padStart(2, '0');
    const year = guatemalaDate.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }

  // Función para cargar atributos de cualquier entidad
  async function loadAtributos(currentEntityId) {
    try {
        const fetchedData = await fetchAtributos(currentEntityId); // Llama a la función de atributos

        if (Array.isArray(fetchedData['atributos'])) {
          return fetchedData['atributos'];
        } else {
          console.error('Se esperaba un array de atributos, pero se obtuvo:', fetchedData);
        }
    } catch (error) {
        console.error('Error al cargar los atributos:', error);
    }
  }

    // Función para cargar impuestos de cualquier entidad
    async function loadImpuestos(currentEntityId) {
    try {
        const fetchedData = await fetchImpuestos(currentEntityId); // Llama a la función de atributos

        if (Array.isArray(fetchedData['impuestos'])) {
          return fetchedData['impuestos'];
        } else {
          console.error('Se esperaba un array de impuestos, pero se obtuvo:', fetchedData);
        }
    } catch (error) {
        console.error('Error al cargar los impuestos:', error);
    }
  }

  // Cargar las opciones de las entidades relacionadas
  async function editObjetos(entity) {
    newEntity = { ...entity };
    currentEntityId = entity.id;
    isObjectPaneOpen = true;
    isDirty = true;
  }

  async function toggleObjectPane() {
    isObjectPaneOpen = !isObjectPaneOpen;
    if (!isObjectPaneOpen) resetForm();
  }

   // Nueva función para verificar el campo crud de role_objeto
  async function checkRoleObjetoCRUD(objetoId, roleId) {
      try {
          // Aquí debes realizar la llamada a la API o a la base de datos para obtener el registro correspondiente
          const data = await pb.collection('role_objeto').getFullList({
              filter: `objeto = '${objetoId}' && role = '${roleId}'`
          });

          // Comprobar si se encontró un registro
          if (data && data.length > 0) {
              // Retornar el campo crud del primer registro encontrado
              return data[0].CRUD;
          } else {
              console.warn(`No se encontró ningún registro para objeto ${objetoId} y role ${roleId}`);
              return null; // o un valor por defecto que prefieras
          }
      } catch (error) {
          console.error('Error al comprobar crud de role_objeto:', error);
          return null; // o un valor por defecto
      }
  }
  
  function handlePasswordChange(userId) {
    selectedUserId = userId;
    showPasswordModal = true;
  }

  function handleClosePasswordModal() {
    showPasswordModal = false;
    selectedUserId = '';
  }
</script>

{#if showComponent}

    <CrudPane
      newEntity={newEntity}
      currentEntityId={currentEntityId}
      isPaneOpen={isPaneOpen}
      togglePane={togglePane}
      saveEntityEntry={saveEntry}
      entityName={entityName}
      editColumns={editColumns}
      on:inputChange={handleInputChange}
      canModify={canModify}
      canCreate={canCreate}
      title={title}
    />

    <CrudObjectPane 
      newEntity={newEntity} 
      isObjectPaneOpen={isObjectPaneOpen} 
      toggleObjectPane={toggleObjectPane} 
    />

    <div class="relative md:pt-6 pb-16 flex justify-between items-center">
      <h2 class="text-white text-lg font-bold">Gestión de {title}</h2>
      <div class="flex items-center ml-auto">
          <Actions 
              {togglePane}
              {exportToExcel}
              {exportToPDF}
              {isMenuOpen}
              {toggleMenu}
              {canCreate}
          />
          &nbsp;
          <input
              type="text"
              bind:value={searchQuery}
              on:input={() => handleSearch(1)}
              placeholder="Buscar ..."
              class="px-4 py-2 border rounded border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ml-4"
          />
      </div>
    </div>
    
    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
      <div class="block w-full overflow-x-auto">
        <table class="items-center w-full bg-transparent border-collapse">
          <thead>
            <tr>
                
              {#each columns as col}
                <th 
                  class="px-6 py-3 text-xs uppercase border border-l-0 border-r-0 font-semibold cursor-pointer"
                  on:click={() => sortTable(col.field)}
                >
                  {col.label}
                  {#if sortColumn === col.field}
                    {#if sortDirection === 'asc'}
                      ▲
                    {:else}
                      ▼
                    {/if}
                  {/if}
                </th>
              {/each}
              <th class="px-6 py-3 text-xs uppercase border border-l-0 border-r-0 font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {#each entities as entity}
              <tr>
                {#each columns as col}
                    <td class="px-6 py-3 text-xs">
                      {#if col.type === 'bool'}
                          {entity[col.field] ? 'Activo' : 'Inactivo'}
                      {:else if col.type === 'date'}
                          {entity[col.field] ? formatDate(entity[col.field]) : ''}
                      {:else if col.type === 'image'}
                        <img src={POCKETBASE_URL+'/api/files/'+entity['collectionId']+'/'+entity['id']+'/'+entity[col.field]} alt="Preview" class="mt-2 w-24 h-24 object-cover" style="width: 100px;" />
                      {:else}
                          {entity[col.field]}
                      {/if}
                    </td>
                {/each}
              
                <td class="px-6 py-3 text-xs text-right">
                  <TableDropdown 
                    onEdit={() => editEntity(entity)} 
                    onDelete={() => deleteEntity(entity.id)} 
                    onObjetos={() => editObjetos(entity)}
                    onPasswordChange={entityName === 'users' ? () => handlePasswordChange(entity.id) : undefined}
                    closeDropdown={() => {}} 
                    entityName={entityName}
                    canDelete={canDelete}
                    canModify={canModify}
                  />
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
    

      <Paginator 
          {currentPage} 
          {totalRecords} 
          {perPage} 
          {itemsPerPageOptions} 
          onPageChange={handlePageChange} 
          onItemsPerPageChange={handleItemsPerPageChange}
      />

  <ChangePasswordModal 
    show={showPasswordModal}
    userId={selectedUserId}
    on:close={handleClosePasswordModal}
  />
{:else}
    <div class="flex items-center justify-center h-96">
        <h2 class="text-2xl text-white z-10">No tienes permiso para acceder a esta sección.</h2>
    </div>
{/if}
